'use client';
import React, { useState } from 'react';
import Link from 'next/link';
import { Glossarieslistingdata } from '@/app/api/fetchjsonsdata';

const GlossaryData = () => {
  const [activeTab, setActiveTab] = useState('All Glossary');
  const [searchTerm, setSearchTerm] = useState('');
  const [sortedLetter, setSortedLetter] = useState(null);

  // Combine the data from both hrmsdata and pmsdata
  const glossaryData = Glossarieslistingdata;

  const handleTabChange = (tab) => {
    setActiveTab(tab);
  };

  const handleSearchChange = (event) => {
    setSearchTerm(event.target.value);
  };

  // Filter the data based on search term or first letter
  const filteredData = sortedLetter
    ? glossaryData[activeTab].filter((item) =>
      item.title.toLowerCase().startsWith(sortedLetter.toLowerCase())
    )
    : glossaryData[activeTab].filter((item) =>
      item.title.toLowerCase().includes(searchTerm.toLowerCase())
    );

  return (
    <div className="container page-section">
      <div className="row justify-content-center">
        <div className="col-md-6 d-flex align-items-center mb-30">
          <div className="input-group mb-3">
            <input
              type="text"
              className="form-control"
              placeholder="Enter your search glossary..."
              value={searchTerm}
              onChange={handleSearchChange}
            />
            <div className="input-group-append">
              <button className="btn btn-mod btn-large btn-round">
                Search
              </button>
            </div>
          </div>
        </div>
      </div>
      <div className="row">
        <div className="col-md-3">
          <ul className="nav flex-column">
            {Object.keys(glossaryData).map((tab) => (
              <li className="nav-item py-2" key={tab}>
                <a
                  className={`nav-link ${activeTab === tab
                    ? 'active bg-black text-white'
                    : 'text-black border border-gray'
                    }`}
                  onClick={() => handleTabChange(tab)}
                // href="#"
                >
                 <h3 style={{fontSize: "18px", paddingTop: '11px'}}>{tab}</h3> 
                </a>
              </li>
            ))}
          </ul>
        </div>
        <div className="col-md-9">
          <div className="row">
            {filteredData.map((item, index) => (
              <div
                className="col-sm-6 col-xl-4 d-flex align-items-stretch transition-transform duration-200 !hover:bg-black !hover:scale-95"
                data-wow-delay="0.1s"
                key={index}
              >
                <div className="alt-features-item box-shadow border border-black rounded-xl text-center">
                  <Link href={`/glossary/${item.slug}/`}
                    style={{ textDecoration: 'none !important' }}
                    className="hover:underline">
                    <h4 className="alt-features-title">{item.title}</h4>
                  </Link>
                </div>
              </div>
            ))}

          </div>
        </div>
      </div>
    </div>
  );
};

export default GlossaryData;
